// extracted by css-extract-rspack-plugin
export default {"clocksGrid":"src-modules-desktop-modules-widgets-components-clock-components-SmallWidgetTimezones-SmallWidgetTimezones-module__clocksGrid-uPJw_b","clockItem":"src-modules-desktop-modules-widgets-components-clock-components-SmallWidgetTimezones-SmallWidgetTimezones-module__clockItem-ES4PUC","tzLabel":"src-modules-desktop-modules-widgets-components-clock-components-SmallWidgetTimezones-SmallWidgetTimezones-module__tzLabel-Ju9Pfb"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"clocksGrid\":\"src-modules-desktop-modules-widgets-components-clock-components-SmallWidgetTimezones-SmallWidgetTimezones-module__clocksGrid-uPJw_b\",\"clockItem\":\"src-modules-desktop-modules-widgets-components-clock-components-SmallWidgetTimezones-SmallWidgetTimezones-module__clockItem-ES4PUC\",\"tzLabel\":\"src-modules-desktop-modules-widgets-components-clock-components-SmallWidgetTimezones-SmallWidgetTimezones-module__tzLabel-Ju9Pfb\"}";
        // 1793875575674
        var cssReload = require("../../../../../../../../../node_modules/.pnpm/@rspack+core@1.5.8_@swc+helpers@0.5.17/node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  